var map = {
	"./add-image.svg": "./app/icons/svg/add-image.svg",
	"./add.svg": "./app/icons/svg/add.svg",
	"./arrow-left.svg": "./app/icons/svg/arrow-left.svg",
	"./arrow-up.svg": "./app/icons/svg/arrow-up.svg",
	"./arrow.svg": "./app/icons/svg/arrow.svg",
	"./back.svg": "./app/icons/svg/back.svg",
	"./bookings.svg": "./app/icons/svg/bookings.svg",
	"./bug.svg": "./app/icons/svg/bug.svg",
	"./calendar.svg": "./app/icons/svg/calendar.svg",
	"./cancel-second.svg": "./app/icons/svg/cancel-second.svg",
	"./cancel.svg": "./app/icons/svg/cancel.svg",
	"./chat-message-cnt.svg": "./app/icons/svg/chat-message-cnt.svg",
	"./chat-message.svg": "./app/icons/svg/chat-message.svg",
	"./check-box-empty.svg": "./app/icons/svg/check-box-empty.svg",
	"./check-box.svg": "./app/icons/svg/check-box.svg",
	"./check.svg": "./app/icons/svg/check.svg",
	"./crop.svg": "./app/icons/svg/crop.svg",
	"./directionArrowsThin.svg": "./app/icons/svg/directionArrowsThin.svg",
	"./discuss.svg": "./app/icons/svg/discuss.svg",
	"./display-cards.svg": "./app/icons/svg/display-cards.svg",
	"./display-list.svg": "./app/icons/svg/display-list.svg",
	"./dock.svg": "./app/icons/svg/dock.svg",
	"./dots.svg": "./app/icons/svg/dots.svg",
	"./edit.svg": "./app/icons/svg/edit.svg",
	"./editContact.svg": "./app/icons/svg/editContact.svg",
	"./enter.svg": "./app/icons/svg/enter.svg",
	"./exclamation-mark.svg": "./app/icons/svg/exclamation-mark.svg",
	"./external-link.svg": "./app/icons/svg/external-link.svg",
	"./eye-dropper.svg": "./app/icons/svg/eye-dropper.svg",
	"./eye.svg": "./app/icons/svg/eye.svg",
	"./filter.svg": "./app/icons/svg/filter.svg",
	"./forbidden-sign.svg": "./app/icons/svg/forbidden-sign.svg",
	"./hand-shake.svg": "./app/icons/svg/hand-shake.svg",
	"./handShakeDark.svg": "./app/icons/svg/handShakeDark.svg",
	"./hour-glass.svg": "./app/icons/svg/hour-glass.svg",
	"./idCard.svg": "./app/icons/svg/idCard.svg",
	"./info.svg": "./app/icons/svg/info.svg",
	"./like.svg": "./app/icons/svg/like.svg",
	"./link.svg": "./app/icons/svg/link.svg",
	"./lobby.svg": "./app/icons/svg/lobby.svg",
	"./location.svg": "./app/icons/svg/location.svg",
	"./lock.svg": "./app/icons/svg/lock.svg",
	"./logout.svg": "./app/icons/svg/logout.svg",
	"./mail-send.svg": "./app/icons/svg/mail-send.svg",
	"./menu.svg": "./app/icons/svg/menu.svg",
	"./next.svg": "./app/icons/svg/next.svg",
	"./ok.svg": "./app/icons/svg/ok.svg",
	"./picture.svg": "./app/icons/svg/picture.svg",
	"./player-btn.svg": "./app/icons/svg/player-btn.svg",
	"./player.svg": "./app/icons/svg/player.svg",
	"./private-message.svg": "./app/icons/svg/private-message.svg",
	"./question.svg": "./app/icons/svg/question.svg",
	"./read-only.svg": "./app/icons/svg/read-only.svg",
	"./remove-sign-second.svg": "./app/icons/svg/remove-sign-second.svg",
	"./schedule.svg": "./app/icons/svg/schedule.svg",
	"./secure.svg": "./app/icons/svg/secure.svg",
	"./send-button.svg": "./app/icons/svg/send-button.svg",
	"./slot.svg": "./app/icons/svg/slot.svg",
	"./speaking.svg": "./app/icons/svg/speaking.svg",
	"./star-active.svg": "./app/icons/svg/star-active.svg",
	"./star.svg": "./app/icons/svg/star.svg",
	"./switch-language.svg": "./app/icons/svg/switch-language.svg",
	"./thumbDown.svg": "./app/icons/svg/thumbDown.svg",
	"./thumbUp.svg": "./app/icons/svg/thumbUp.svg",
	"./time.svg": "./app/icons/svg/time.svg",
	"./trash.svg": "./app/icons/svg/trash.svg",
	"./triangle-bottom.svg": "./app/icons/svg/triangle-bottom.svg",
	"./triangle-top.svg": "./app/icons/svg/triangle-top.svg",
	"./undock.svg": "./app/icons/svg/undock.svg",
	"./update.svg": "./app/icons/svg/update.svg",
	"./upload.svg": "./app/icons/svg/upload.svg",
	"./user-profile.svg": "./app/icons/svg/user-profile.svg",
	"./user.svg": "./app/icons/svg/user.svg",
	"./users-export.svg": "./app/icons/svg/users-export.svg",
	"./users.svg": "./app/icons/svg/users.svg",
	"./zoom-in.svg": "./app/icons/svg/zoom-in.svg",
	"./zoom-out.svg": "./app/icons/svg/zoom-out.svg",
	"app/icons/svg/add-image.svg": "./app/icons/svg/add-image.svg",
	"app/icons/svg/add.svg": "./app/icons/svg/add.svg",
	"app/icons/svg/arrow-left.svg": "./app/icons/svg/arrow-left.svg",
	"app/icons/svg/arrow-up.svg": "./app/icons/svg/arrow-up.svg",
	"app/icons/svg/arrow.svg": "./app/icons/svg/arrow.svg",
	"app/icons/svg/back.svg": "./app/icons/svg/back.svg",
	"app/icons/svg/bookings.svg": "./app/icons/svg/bookings.svg",
	"app/icons/svg/bug.svg": "./app/icons/svg/bug.svg",
	"app/icons/svg/calendar.svg": "./app/icons/svg/calendar.svg",
	"app/icons/svg/cancel-second.svg": "./app/icons/svg/cancel-second.svg",
	"app/icons/svg/cancel.svg": "./app/icons/svg/cancel.svg",
	"app/icons/svg/chat-message-cnt.svg": "./app/icons/svg/chat-message-cnt.svg",
	"app/icons/svg/chat-message.svg": "./app/icons/svg/chat-message.svg",
	"app/icons/svg/check-box-empty.svg": "./app/icons/svg/check-box-empty.svg",
	"app/icons/svg/check-box.svg": "./app/icons/svg/check-box.svg",
	"app/icons/svg/check.svg": "./app/icons/svg/check.svg",
	"app/icons/svg/crop.svg": "./app/icons/svg/crop.svg",
	"app/icons/svg/directionArrowsThin.svg": "./app/icons/svg/directionArrowsThin.svg",
	"app/icons/svg/discuss.svg": "./app/icons/svg/discuss.svg",
	"app/icons/svg/display-cards.svg": "./app/icons/svg/display-cards.svg",
	"app/icons/svg/display-list.svg": "./app/icons/svg/display-list.svg",
	"app/icons/svg/dock.svg": "./app/icons/svg/dock.svg",
	"app/icons/svg/dots.svg": "./app/icons/svg/dots.svg",
	"app/icons/svg/edit.svg": "./app/icons/svg/edit.svg",
	"app/icons/svg/editContact.svg": "./app/icons/svg/editContact.svg",
	"app/icons/svg/enter.svg": "./app/icons/svg/enter.svg",
	"app/icons/svg/exclamation-mark.svg": "./app/icons/svg/exclamation-mark.svg",
	"app/icons/svg/external-link.svg": "./app/icons/svg/external-link.svg",
	"app/icons/svg/eye-dropper.svg": "./app/icons/svg/eye-dropper.svg",
	"app/icons/svg/eye.svg": "./app/icons/svg/eye.svg",
	"app/icons/svg/filter.svg": "./app/icons/svg/filter.svg",
	"app/icons/svg/forbidden-sign.svg": "./app/icons/svg/forbidden-sign.svg",
	"app/icons/svg/hand-shake.svg": "./app/icons/svg/hand-shake.svg",
	"app/icons/svg/handShakeDark.svg": "./app/icons/svg/handShakeDark.svg",
	"app/icons/svg/hour-glass.svg": "./app/icons/svg/hour-glass.svg",
	"app/icons/svg/idCard.svg": "./app/icons/svg/idCard.svg",
	"app/icons/svg/info.svg": "./app/icons/svg/info.svg",
	"app/icons/svg/like.svg": "./app/icons/svg/like.svg",
	"app/icons/svg/link.svg": "./app/icons/svg/link.svg",
	"app/icons/svg/lobby.svg": "./app/icons/svg/lobby.svg",
	"app/icons/svg/location.svg": "./app/icons/svg/location.svg",
	"app/icons/svg/lock.svg": "./app/icons/svg/lock.svg",
	"app/icons/svg/logout.svg": "./app/icons/svg/logout.svg",
	"app/icons/svg/mail-send.svg": "./app/icons/svg/mail-send.svg",
	"app/icons/svg/menu.svg": "./app/icons/svg/menu.svg",
	"app/icons/svg/next.svg": "./app/icons/svg/next.svg",
	"app/icons/svg/ok.svg": "./app/icons/svg/ok.svg",
	"app/icons/svg/picture.svg": "./app/icons/svg/picture.svg",
	"app/icons/svg/player-btn.svg": "./app/icons/svg/player-btn.svg",
	"app/icons/svg/player.svg": "./app/icons/svg/player.svg",
	"app/icons/svg/private-message.svg": "./app/icons/svg/private-message.svg",
	"app/icons/svg/question.svg": "./app/icons/svg/question.svg",
	"app/icons/svg/read-only.svg": "./app/icons/svg/read-only.svg",
	"app/icons/svg/remove-sign-second.svg": "./app/icons/svg/remove-sign-second.svg",
	"app/icons/svg/schedule.svg": "./app/icons/svg/schedule.svg",
	"app/icons/svg/secure.svg": "./app/icons/svg/secure.svg",
	"app/icons/svg/send-button.svg": "./app/icons/svg/send-button.svg",
	"app/icons/svg/slot.svg": "./app/icons/svg/slot.svg",
	"app/icons/svg/speaking.svg": "./app/icons/svg/speaking.svg",
	"app/icons/svg/star-active.svg": "./app/icons/svg/star-active.svg",
	"app/icons/svg/star.svg": "./app/icons/svg/star.svg",
	"app/icons/svg/switch-language.svg": "./app/icons/svg/switch-language.svg",
	"app/icons/svg/thumbDown.svg": "./app/icons/svg/thumbDown.svg",
	"app/icons/svg/thumbUp.svg": "./app/icons/svg/thumbUp.svg",
	"app/icons/svg/time.svg": "./app/icons/svg/time.svg",
	"app/icons/svg/trash.svg": "./app/icons/svg/trash.svg",
	"app/icons/svg/triangle-bottom.svg": "./app/icons/svg/triangle-bottom.svg",
	"app/icons/svg/triangle-top.svg": "./app/icons/svg/triangle-top.svg",
	"app/icons/svg/undock.svg": "./app/icons/svg/undock.svg",
	"app/icons/svg/update.svg": "./app/icons/svg/update.svg",
	"app/icons/svg/upload.svg": "./app/icons/svg/upload.svg",
	"app/icons/svg/user-profile.svg": "./app/icons/svg/user-profile.svg",
	"app/icons/svg/user.svg": "./app/icons/svg/user.svg",
	"app/icons/svg/users-export.svg": "./app/icons/svg/users-export.svg",
	"app/icons/svg/users.svg": "./app/icons/svg/users.svg",
	"app/icons/svg/zoom-in.svg": "./app/icons/svg/zoom-in.svg",
	"app/icons/svg/zoom-out.svg": "./app/icons/svg/zoom-out.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/icons/svg sync recursive \\.svg$";